module.exports = __webpack_public_path__ + "static/media/music-club-shop.fce1e770.png";